import serviceInfo from "../views/serviceInfo";

export default [
  {
    path: "/serviceInfo/main",
    name: "서비스소개",
    component: serviceInfo,
  },
];
